import { Pipe, PipeTransform } from '@angular/core';

import { canaisMidiasSociais } from '../canal-midia-social';

@Pipe({
    name: 'canalMidiaSocial'
})
export class CanalMidiaSocialPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = canaisMidiasSociais.findIndex(canal => canal.id === value);
        if (index > -1) {
            return canaisMidiasSociais[index].nome;
        }
        return '';
    }
}
